<template>
    <div>
        <el-input
            :placeholder="placeholder"
            :disabled="disabled"
            :size="size"
            :readonly="isReadonly"
            @blur="changeVal"
            v-model="address"
            class="input-with-select"
            width="60%"
        >
            <el-button slot="append" :disabled="disabled" @click="showSelectDialog" icon="el-icon-location"></el-button>
        </el-input>
        <el-dialog title="位置选择" :close-on-click-modal="false" :append-to-body="true" :visible.sync="visible" width="850px">

            <maps
                ref="map"
                @getPosition="getPosition"
                :areaTreeDate="areaTreeDate"
                :longitude="longitude"
                :latitude="latitude"
                :provinceId="provinceId"
                :cityId="cityId"
                :areaId="areaId"
                :streetId="streetId"
                :address="address"
            ></maps>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogClose()">关闭</el-button>
                <el-button type="primary" @click="doSubmit()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import maps from "@/components/map/map.vue"
export default {
    components:{
        maps
    },
    mounted() {
        console.log("1")
        console.log(this.longitude,this.latitude)
    },
    data() {
        return {
            name: '',
            visible: false,
        };
    },
    props: {
        size: {
            type: String,
            default: () => {
                return 'small';
            }
        },
        areaTreeDate:{
            type: Array,
            default: []
        },
        longitude:{
            type: String,
            default: ''
        },
        latitude:{
            type: String,
            default: ''
        },
        provinceId:{
            type: String,
            default: ''
        },
        cityId:{
            type: String,
            default: ''
        },
        areaId:{
            type: String,
            default: ''
        },
        streetId:{
            type: String,
            default: ''
        },
        address:{
            type: String,
            default: ''
        },


        placeholder: {
            type: String,
            default: '请选择'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        isReadonly: {
            type: Boolean,
            default: true
        },
        token: {
            type: String,
            default: localStorage.getItem('token')
        }
    },
    methods:{
        showSelectDialog(){
            this.visible = true
            this.$nextTick(()=>{
                this.$refs.map.initialize();
            })
        },
        dialogClose(){
            this.visible = false
        },
        doSubmit(){
            this.$refs.map.sendForm();
        },
        changeVal(){

        },
        getPosition(location){
            this.name = location.address
            this.$emit('getLocation',location)
            this.visible = false
        }
    }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.i1 {
    width: 50px;
    height: 50px;
    display: block;
    margin-left: 50%;
    transform: translate(-50%, 0);
}
</style>
